(function () {
  function refreshCartUI() {
    return fetch('?section_id=helper-cart')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var newForm = doc.getElementById('AjaxCartForm');
        var newSub = doc.getElementById('AjaxCartSubtotal');
        var liveForm = document.getElementById('AjaxCartForm');
        var liveSub = document.getElementById('AjaxCartSubtotal');
        if (newForm && liveForm) {
          liveForm.innerHTML = newForm.innerHTML;
          if (typeof liveForm.ajaxifyCartItems === 'function') liveForm.ajaxifyCartItems();
        }
        if (newSub && liveSub) liveSub.innerHTML = newSub.innerHTML;
        var newCount = doc.querySelector('[data-cart-count]');
        if (newCount) {
          document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
            el.textContent = newCount.textContent;
          });
        }
        var newTotal = doc.querySelector('[data-cart-total]');
        if (newTotal) {
          document.querySelectorAll('[data-header-cart-total]').forEach(function (el) {
            el.textContent = newTotal.textContent;
          });
        }
        var sidebar = document.getElementById('site-cart-sidebar');
        if (sidebar && typeof sidebar.show === 'function') sidebar.show();
        var recs = document.getElementById('cart-recommendations');
        if (recs && typeof recs.generateRecommendations === 'function') recs.generateRecommendations();
      });
  }

  function moneyFormat(cents) {
    var n = (cents / 100).toFixed(2);
    return '£' + n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function init(root) {
    if (!root || root.dataset.pairInit === '1') return;
    root.dataset.pairInit = '1';

    var form = root.querySelector('[data-pair-product-form]');
    var idInput = root.querySelector('[data-pair-variant-id]');
    var atc = root.querySelector('[data-pair-atc]');
    var labelEl = root.querySelector('[data-pair-text]');
    var priceEl = root.querySelector('[data-pair-price]');
    var compareEl = root.querySelector('[data-pair-compare]');
    var imageEl = root.querySelector('.pair-product__image');

    var variantsEl = root.querySelector('[data-pair-variants]');
    var variants = [];
    if (variantsEl) {
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) { variants = []; }
    }

    function selectedOptions() {
      var picked = {};
      root.querySelectorAll('.pair-product__swatch.is-selected').forEach(function (sw) {
        var pos = parseInt(sw.dataset.pairOptionPosition, 10);
        picked[pos] = sw.dataset.pairOptionValue;
      });
      return picked;
    }

    function findVariant(picked) {
      return variants.find(function (v) {
        for (var k in picked) {
          var key = 'option' + k;
          if (v[key] !== picked[k]) return false;
        }
        return true;
      });
    }

    function applyVariant(v) {
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = moneyFormat(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = moneyFormat(v.compare_at_price);
          compareEl.removeAttribute('hidden');
        } else {
          compareEl.textContent = '';
          compareEl.setAttribute('hidden', '');
        }
      }
      if (atc && labelEl) {
        if (v.available) {
          atc.removeAttribute('disabled');
          labelEl.textContent = labelEl.dataset.originalLabel || labelEl.textContent;
        } else {
          atc.setAttribute('disabled', 'disabled');
          if (!labelEl.dataset.originalLabel) labelEl.dataset.originalLabel = labelEl.textContent;
          labelEl.textContent = 'Sold out';
        }
      }
      if (imageEl && v.featured_image && v.featured_image.src) {
        var src = v.featured_image.src;
        var url = src.indexOf('//') === 0 ? 'https:' + src : src;
        var sep = url.indexOf('?') === -1 ? '?' : '&';
        imageEl.src = url + sep + 'width=240';
        imageEl.removeAttribute('srcset');
        if (v.featured_image.alt) imageEl.alt = v.featured_image.alt;
      }
    }

    function updateSelectedLabel() {
      root.querySelectorAll('[data-pair-option-selected]').forEach(function (lbl) {
        var pos = lbl.getAttribute('data-pair-option-selected');
        var sw = root.querySelector('.pair-product__swatch.is-selected[data-pair-option-position="' + pos + '"]');
        if (sw) lbl.textContent = sw.dataset.pairOptionValue;
      });
    }

    root.querySelectorAll('.pair-product__swatch').forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault();
        if (sw.classList.contains('is-unavailable')) return;
        var pos = sw.dataset.pairOptionPosition;
        root.querySelectorAll('.pair-product__swatch[data-pair-option-position="' + pos + '"]').forEach(function (s) {
          s.classList.remove('is-selected');
          s.setAttribute('aria-checked', 'false');
        });
        sw.classList.add('is-selected');
        sw.setAttribute('aria-checked', 'true');
        var picked = selectedOptions();
        var v = findVariant(picked);
        applyVariant(v);
        updateSelectedLabel();
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!idInput || !idInput.value) return;
        var originalLabel = labelEl ? labelEl.textContent : '';
        if (labelEl && !labelEl.dataset.originalLabel) labelEl.dataset.originalLabel = originalLabel;
        atc.setAttribute('disabled', 'disabled');
        if (labelEl) labelEl.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: idInput.value, quantity: 1 }),
        })
          .then(function (r) {
            return r.json().then(function (d) { return { ok: r.ok, data: d }; });
          })
          .then(function (res) {
            if (!res.ok) throw new Error((res.data && res.data.description) || 'Add to cart failed');
            if (labelEl) labelEl.textContent = 'Added ✓';
            return refreshCartUI();
          })
          .then(function () {
            setTimeout(function () {
              if (labelEl) labelEl.textContent = labelEl.dataset.originalLabel || originalLabel;
              atc.removeAttribute('disabled');
            }, 1500);
          })
          .catch(function () {
            if (labelEl) labelEl.textContent = 'Try again';
            setTimeout(function () {
              if (labelEl) labelEl.textContent = labelEl.dataset.originalLabel || originalLabel;
              atc.removeAttribute('disabled');
            }, 1800);
          });
      });
    }
  }

  function bootstrap() {
    document.querySelectorAll('.pair-product').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
